// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "breadcrumb-UT1Ua";
export { _1 as "__esModule", _2 as "tablet", _3 as "breadcrumb" }
export default { "__esModule": _1, "tablet": _2, "breadcrumb": _3 }
